// extracted by mini-css-extract-plugin
export default {"dealer-notification-details-button":"dealer-notification-details-button_kovRgWGo","dealer-notification-popup-content":"dealer-notification-popup-content_v1Y1bL7N"};